// components/dashboard/widgets/TopCursos.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Spin, Empty, List, Progress } from 'antd';
import { TrophyOutlined } from '@ant-design/icons';
import { useDashboardData } from '../../../hooks/useDashboardData';

const TopCursos = ({ endpoint, filtros }) => {
  const { dados, loading, error } = useDashboardData(endpoint, filtros);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: 40 }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        padding: '20px', 
        textAlign: 'center', 
        backgroundColor: '#fff2f0',
        border: '1px solid #ffccc7',
        borderRadius: '6px',
        color: '#a8071a'
      }}>
        <p style={{ margin: '0 0 4px 0', fontWeight: 'bold' }}>
          Erro ao carregar ranking
        </p>
        <small style={{ color: '#cf1322' }}>{error}</small>
      </div>
    );
  }

  if (!dados?.length) {
    return <Empty description="Nenhum curso encontrado" />;
  }

  // Encontrar o máximo para calcular percentuais
  const maxDefesas = Math.max(...dados.map(item => item.total_defesas || 0));

  // Cores para o ranking
  const cores = ['#f5222d', '#fa8c16', '#fadb14', '#52c41a', '#1890ff', '#722ed1', '#eb2f96', '#13c2c2'];

  const getMedalha = (index) => {
    if (index === 0) return '🥇';
    if (index === 1) return '🥈'; 
    if (index === 2) return '🥉';
    return `${index + 1}º`;
  };

  return (
    <div style={{ height: 350, overflowY: 'auto' }}>
      <List
        dataSource={dados.slice(0, 10)} // Top 10
        renderItem={(item, index) => (
          <List.Item style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
            <div style={{ width: '100%' }}>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                marginBottom: 8
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ 
                    fontSize: 16,
                    fontWeight: 'bold',
                    minWidth: 30
                  }}>
                    {getMedalha(index)}
                  </span>
                  <span style={{ 
                    fontWeight: index < 3 ? 'bold' : 'normal',
                    fontSize: index < 3 ? 14 : 13,
                    color: index < 3 ? '#262626' : '#595959'
                  }}>
                    {item.curso || item.area_especializacao}
                  </span>
                </div>
                <span style={{ 
                  fontWeight: 'bold',
                  color: cores[index] || '#1890ff',
                  fontSize: 14
                }}>
                  {item.total_defesas || 0}
                </span>
              </div>
              
              <Progress
                percent={maxDefesas > 0 ? Math.round(((item.total_defesas || 0) / maxDefesas) * 100) : 0}
                strokeColor={cores[index] || '#1890ff'}
                size="small"
                showInfo={false}
                style={{ marginBottom: 4 }}
              />
              
              {/* Informações adicionais */}
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between',
                fontSize: 11, 
                color: '#8c8c8c'
              }}>
                {item.realizadas !== undefined && (
                  <span>Realizadas: {item.realizadas}</span>
                )}
                {item.nota_media && (
                  <span>Nota Média: {item.nota_media}</span>
                )}
                {item.taxa_conclusao && (
                  <span>Taxa: {item.taxa_conclusao}%</span>
                )}
              </div>
            </div>
          </List.Item>
        )}
      />
      
      {dados.length > 10 && (
        <div style={{ 
          textAlign: 'center', 
          padding: 8, 
          color: '#8c8c8c',
          fontSize: 12
        }}>
          E mais {dados.length - 10} cursos...
        </div>
      )}

      {dados.length === 0 && (
        <div style={{ 
          textAlign: 'center', 
          padding: 20, 
          color: '#8c8c8c'
        }}>
          Nenhum curso com defesas no período selecionado
        </div>
      )}
    </div>
  );
};

// PropTypes
TopCursos.displayName = 'TopCursos';
TopCursos.propTypes = {
  endpoint: PropTypes.string.isRequired,
  filtros: PropTypes.object
};

TopCursos.defaultProps = {
  filtros: {}
};

export default TopCursos;